import { render } from "./DataManagement.vue?vue&type=template&id=31f592b5&scoped=true"
import script from "./DataManagement.vue?vue&type=script&lang=js"
export * from "./DataManagement.vue?vue&type=script&lang=js"

import "./DataManagement.vue?vue&type=style&index=0&id=31f592b5&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f592b5"]])

export default __exports__